export function getBase64FromDataUrl(dataUrl: string) {
    const commaIndex = dataUrl.indexOf(",");
    return commaIndex < 0 ? dataUrl : dataUrl.substring(commaIndex + 1);
}

export function createEmptyImageDataUrl(width: number, height: number): string {
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    return canvas.toDataURL("image/png");
}

export function loadImage(uri: string) {
    return new Promise<HTMLImageElement>((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = uri;
    });
}
